const initialState = {
    client: null,
    state: 'not_initialized',
    onClients: [],
};

const pushReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'PUSH_STATE':
      return {
          ...state,
        state: action.state,
      };
    case 'WAIT_CLIENT':
      return {
        ...state,
        onClients: [...state.onClients, action.onClient],
      };
    case 'SET_CLIENT':
      state.onClients.map(onClient=>onClient(action.client));
      return {
        ...state,
        client: action.client,
        onClients: []
      };
    default:
      return state;
  }
};

export default pushReducer;



// WEBPACK FOOTER //
// ./src/reducers/PushReducer.js